export default {
	resetSession: '/api/user/session/reset',
};
